/*
 * MUTE Consent Handler — Phase 1 Refactor (2026-05-23)
 * Wires the [data-mute-cookie-settings] button in the footer to a
 * consent-reset flow. Works with the Consentmo Hardening v2 stack:
 *
 *   1. Delete cookieconsent_status (Consentmo's main consent cookie)
 *   2. Delete cookieconsent_preferences_disabled (Consentmo's suppress cookie)
 *   3. Reload the page → Consentmo banner (if present) reappears, OR
 *      the consent_hardening.liquid script re-initializes its deny-by-default
 *      stance. Either way the user sees a fresh consent state.
 *
 * If no consent vendor is currently active (e.g. Consentmo App disabled),
 * the click still resets all consent cookies, so the user gets a clean state.
 *
 * The button must exist with attribute [data-mute-cookie-settings] (currently
 * in sections/mute-footer.liquid copyright strip).
 */
(function () {
  'use strict';

  const COOKIE_NAMES = [
    'cookieconsent_status',
    'cookieconsent_preferences_disabled',
    'cookieconsent_dismissed'
  ];

  function deleteCookie(name) {
    const expires = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = name + '=' + expires;
    try {
      const host = location.hostname.replace(/^www\./, '');
      document.cookie = name + '=' + expires + '; domain=.' + host;
      document.cookie = name + '=' + expires + '; domain=' + host;
    } catch (_) { /* noop */ }
  }

  function resetConsent() {
    COOKIE_NAMES.forEach(deleteCookie);
    // Also re-init Shopify's customer privacy to deny-by-default
    try {
      if (window.Shopify && window.Shopify.customerPrivacy
          && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: 'no', marketing: 'no', preferences: 'no', sale_of_data: 'no' },
          function () { /* noop */ }
        );
      }
    } catch (_) { /* noop */ }
  }

  function onCookieClick(e) {
    e.preventDefault();

    // If a consent vendor exposes a native "open preferences" API, use it
    // (delegated future-friendly hook for when Consentmo/Cookiebot/etc. ships).
    try {
      if (window.Consentmo && typeof window.Consentmo.openPreferences === 'function') {
        window.Consentmo.openPreferences();
        return;
      }
      if (window.Cookiebot && typeof window.Cookiebot.show === 'function') {
        window.Cookiebot.show();
        return;
      }
      if (typeof window._cmpReshowBanner === 'function') {
        window._cmpReshowBanner();
        return;
      }
    } catch (_) { /* noop */ }

    // Fallback: reset cookies + reload → Consent-Hardening re-init
    resetConsent();
    // Reload to current URL preserving query (preview_theme_id stays intact)
    window.location.reload();
  }

  function init() {
    const buttons = document.querySelectorAll('[data-mute-cookie-settings]');
    if (!buttons.length) return;
    buttons.forEach((btn) => btn.addEventListener('click', onCookieClick));
  }

  window.MuteConsent = { reset: resetConsent };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
